export default __webpack_public_path__ + "176f8f5bd5f02b3abfcf894955d7e919.woff2";